<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" 
         :actions="actions" :actionEvent="actionEvent" :addUrl="'Dealer/ServiceForms/'+$route.params.id+'/Movements/Add'" 
         :mode="mode" :gSearch="gSearch" :rightMenus="rightMenus" :rmClick="rmClick" />
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />

    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/";

    let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.serviceForms'), url: '/Dealer/ServiceForms' },
        { label: i18n.t('pages.dealer.serviceFormMovements'), url: '' }
    ]
     let fields = [ 
         { key: 'date', type: 'date', label: 'İşlem Tarihi', keys:['date']},
         { key: 'name', label: 'Yetkili Adı', keys:['person_name']},
         { key: 'surname', label: 'Yetkili Soyadı', keys:['person_surname'] },
         { key: 'desc', label: 'İşlem', keys:['description'] },
         { key: 'detection', label: 'Tespit', keys:['detection'] },
         { key: 'actions', label: i18n.t('dealer.list.actions') }        
    ]; 

    let actions = [
        {key: 'movement', text: 'Hareket Ekle', state: 0},
        {key: 'photo', text: "Harekete Ait Görüntüler", state: 0},
        {key: 'product', text: 'Harekete Ait Ürünler', state: 0}
    ]

    let filtered = ['date',"name", 'surname', 'desc', 'detection', 'actions']; 

    export default {
        name: 'ServiceForms',
         created: async function(){
            this.params.id = this.$route.params.id
            await this.$store.dispatch('serviceFormMovementList', this.params)
        },
        computed:{
            loading(){
                return this.$store.getters.getDealerLoading
            },
            list(){
                return this.$store.getters.serviceMovementsList
            },
            pageInfo(){
                return this.$store.getters.serviceFormPageInfo
            }
        },
          watch:{
            limit(val){
                this.params['limit'] = val
                this.$store.dispatch('appointment_get', this.params)
            },
            offset(val){
                 this.params['offset'] = val
                 this.$store.dispatch('appointment_get', this.params)
            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, page: 1, actions, modalOpen: false,
                modalProps: {}, currentForm:"ServiceForm", modalName: "", params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        methods:{
            search(){
                this.inputs.map((input)=>{
                    input.checked ? this.params[input.key] = input.val : delete this.params[input.key]
                })
                this.$store.dispatch('getAccounts', this.params)
            },
            setLimit:function(limit){
                this.limit = limit
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                }
            },
            actionEvent: async function(key, data){
                switch(key){
                    case 'movement': 
                        this.$router.push( { path: '/Dealer/ServiceForms/'+this.$route.params.id+'/Movements/Add'})
                        break;
                    case 'product':
                        this.openModal(true, 'Products', { products: data.products });
                        break;

                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Dealer/ServiceFormMovements.vue